import React from 'react';
import { modules } from '../data/content';
export function Modules() {
  return <section className="bg-ice px-3 py-4 sm:px-6" data-id="element-104" data-mp="1r63rh4h50cko">
      <div className="mx-auto max-w-2xl" data-id="element-105" data-mp="1r4sq1bb5zgwq">
        <h2 className="text-center font-heading text-[1.2rem] font-extrabold uppercase text-navy sm:text-[1.85rem]" data-id="element-106" data-mp="1vx2e0lspy6wd">
          What’s included
        </h2>
        <div className="mt-2 space-y-2" data-id="element-107" data-mp="20vne8l7z0qkt">
          {modules.map(mod => <article key={mod.number} className="overflow-hidden rounded-md border border-navy/10 bg-white shadow-sm" data-id="element-108" data-mp="146xsukx4xfu3">
              <div className="flex items-center gap-1.5 bg-navy px-2.5 py-1.5" data-id="element-109" data-mp="1d6kloibstdbj">
                <span className="text-[0.8rem] leading-none" aria-hidden="true" data-id="element-110" data-mp="1d8nhxk3jo2op">
                  ✅
                </span>
                <h3 className="font-heading text-[0.72rem] font-extrabold uppercase leading-tight tracking-wide text-white sm:text-[0.9rem]" data-id="element-111" data-mp="2olzr8ai2pdi9">
                  Module {mod.number} — {mod.title}
                </h3>
              </div>
              <div className="px-2.5 py-2" data-id="element-112" data-mp="1u1hz3tk8ng6">
                {mod.lines.map(line => <p key={line} className="mt-0.5 text-[0.8rem] leading-[1.35] text-muted first:mt-0 sm:text-[0.95rem]" data-id="element-113" data-mp="3tzx1zlaztdb2">
                    {line}
                  </p>)}
                <p className="mt-1 font-heading text-[0.68rem] font-bold uppercase tracking-wide text-brightblue sm:text-[0.8rem]" data-id="element-114" data-mp="3k2sg7ml27jus">
                  {mod.steps}
                </p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}